import Web3 from 'web3';
import Mount_ABI from './fightercontractabi.json';
import { FighterMOUNT_CONTRACT } from '../../../../config';

console.log("Mount_ABI is array:", Array.isArray(Mount_ABI), Mount_ABI.length);
console.log("FighterMOUNT_CONTRACT:", FighterMOUNT_CONTRACT);

const MULTIVAC_CHAIN_ID = 62621; // decimal

export async function MountFunction({
    walletAddress,
    nftId,
    collectionAddress, // NFT contract address for the NFT being mounted
    onStatus,
    onSuccess,
    onError
}) {
    try {
        if (!window.ethereum) throw new Error('MetaMask is not installed!');

        const web3 = new Web3(window.ethereum);

        onStatus('Validating user session...');
        if (!walletAddress) throw new Error("Missing wallet address.");

        // -- Switch to MultiVAC, and add if needed --
        onStatus('Switching to MultiVAC network...');
        const chainIdHex = `0x${MULTIVAC_CHAIN_ID.toString(16)}`;
        try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: chainIdHex }],
            });
        } catch (switchError) {
            // If chain not found, add it
            if (switchError.code === 4902 || (switchError.data && switchError.data.originalError && switchError.data.originalError.code === 4902)) {
                onStatus('MultiVAC not found. Adding MultiVAC to MetaMask...');
                try {
                    await window.ethereum.request({
                        method: 'wallet_addEthereumChain',
                        params: [{
                            chainId: chainIdHex,
                            chainName: 'MultiVAC',
                            rpcUrls: ['https://rpc.mtv.ac'],
                            nativeCurrency: {
                                name: 'MTV',
                                symbol: 'MTV',
                                decimals: 18
                            },
                            blockExplorerUrls: ['https://e.mtv.ac/index.html']
                        }]
                    });
                    // Now switch
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: chainIdHex }],
                    });
                } catch (addError) {
                    throw new Error('Failed to add MultiVAC network to MetaMask. Please add it manually.');
                }
            } else {
                throw switchError;
            }
        }

        // Step 3: Get account
        onStatus('Fetching wallet address...');
        const accounts = await web3.eth.getAccounts();
        const account = accounts[0];
        if (account.toLowerCase() !== walletAddress.toLowerCase())
            throw new Error("Wallet mismatch. Please select the correct account in MetaMask.");

        // Step 4: Check NFT ownership
        const ERC721_ABI = [
            { "constant": true, "inputs": [{ "name": "tokenId", "type": "uint256" }], "name": "ownerOf", "outputs": [{ "name": "", "type": "address" }], "type": "function" },
            { "constant": true, "inputs": [{ "name": "tokenId", "type": "uint256" }], "name": "getApproved", "outputs": [{ "name": "", "type": "address" }], "type": "function" },
            { "constant": false, "inputs": [{ "name": "to", "type": "address" }, { "name": "tokenId", "type": "uint256" }], "name": "approve", "outputs": [], "type": "function" }
        ];

        const nftContract = new web3.eth.Contract(ERC721_ABI, collectionAddress);

        onStatus('Verifying NFT ownership...');
        const nftOwner = await nftContract.methods.ownerOf(nftId).call();
        if (nftOwner.toLowerCase() !== account.toLowerCase())
            throw new Error("You are not the owner of this NFT!");

        onStatus('Checking NFT approval...');
        const approved = await nftContract.methods.getApproved(nftId).call();

        const gasPrice = await web3.eth.getGasPrice();

        if (approved.toLowerCase() !== FighterMOUNT_CONTRACT.toLowerCase()) {
            onStatus('Approving NFT for transfer...');
            const approveData = nftContract.methods.approve(FighterMOUNT_CONTRACT, nftId).encodeABI();
            const approveTx = {
                from: account,
                to: collectionAddress,
                gas: 100000,
                gasPrice: gasPrice,
                data: approveData
            };
            await web3.eth.sendTransaction(approveTx);
        } else {
            onStatus('NFT is already approved for transfer.');
        }

        // Step 5: Call mount() on the FighterMount contract (legacy)
        if (!FighterMOUNT_CONTRACT || typeof FighterMOUNT_CONTRACT !== 'string' || !FighterMOUNT_CONTRACT.startsWith('0x') || FighterMOUNT_CONTRACT.length !== 42) {
            throw new Error("Contract address not specified or invalid at runtime!");
        }
        if (!Mount_ABI || !Array.isArray(Mount_ABI) || Mount_ABI.length === 0) {
            throw new Error("Mount_ABI not loaded correctly at runtime!");
        }
        const mountContract = new web3.eth.Contract(Mount_ABI, FighterMOUNT_CONTRACT);

        onStatus('Mounting NFT on chain...');
        const gasEstimate = await mountContract.methods.mount(collectionAddress, nftId).estimateGas({ from: account });
        const gasLimit = Number(gasEstimate) + 50000;
        const data = mountContract.methods.mount(collectionAddress, nftId).encodeABI();
        const txObject = {
            from: account,
            to: FighterMOUNT_CONTRACT,
            gas: gasLimit,
            gasPrice: gasPrice,
            data: data
        };
        console.log("TX OBJECT", txObject); // Should show legacy fields only!
        await web3.eth.sendTransaction(txObject);

        onStatus('Fighter mounted successfully! ');
        setTimeout(() => onSuccess && onSuccess(), 1200);

    } catch (err) {
        onError && onError(err.message || "An error occurred during mounting.");
    }
}
